import { SdkResource } from './common';

export const quiz = SdkResource.from((client) => ({
  getById: (id: string) =>
    client
      .GET('/quiz/{id}', {
        params: { path: { id } },
      })
      .then(({ data: response }) => response?.data || null),
}));
